import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-consignment-batch-consignments',
  templateUrl: './consignment-batch-consignments.component.html',
  styleUrls: ['./consignment-batch-consignments.component.css']
})
export class ConsignmentBatchConsignmentsComponent implements OnInit {
    consignmentBatchKeyno;

    public itemsListConsignments: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.consignmentBatchKeyno = this.stateService.getStateParams()['consignmentbatch_keyno'];
    }

    private async loadConsignments() {
        if (!this.consignmentBatchKeyno) return;

        this.itemsListConsignments = await this.datatask.Post(329, { consignmentbatch_keyno: this.consignmentBatchKeyno });
    }

    private async init() {
        this.loadConsignments();
    }

    ngOnInit() {
        this.init();
    }
}
